import type { Nullable } from '../typescript/nullable';

export enum PlanId {
	TRIAL = 1,
	BASIC = 2,
	STARTER = 3,
	CORE = 4,
	PRO = 5,
	BUSINESS = 6,
	ELITE = 7,
	ENTERPRISE = 8,
	ULTIMATE = 9,
}

export const planIdToName: Record<PlanId, string> = {
	[PlanId.TRIAL]: 'Trial',
	[PlanId.BASIC]: 'Basic',
	[PlanId.STARTER]: 'Starter',
	[PlanId.CORE]: 'Core',
	[PlanId.PRO]: 'Pro',
	[PlanId.BUSINESS]: 'Business',
	[PlanId.ELITE]: 'Elite',
	[PlanId.ENTERPRISE]: 'Enterprise',
	[PlanId.ULTIMATE]: 'Ultimate',
};

export enum PlanSubscriptionStatus {
	INACTIVE = 'INACTIVE',
	ACTIVE = 'ACTIVE',
	CANCELLED = 'CANCELLED',
	EXPIRED = 'EXPIRED',
}

export enum PlanSubscriptionBillingProvider {
	NONE = 'NONE',
	STRIPE = 'STRIPE',
	ALIBABA = 'ALIBABA',
}

export interface PlanSubscriptionInterface {
	id: string;
	userId: string;
	planId: PlanId;
	status: PlanSubscriptionStatus;
	billingProvider: PlanSubscriptionBillingProvider;
	expiresAt: Nullable<Date>;
	createdAt: Date;
	activatedAt: Nullable<Date>;
	cancelledAt: Nullable<Date>;
}
